import React, { useState, useEffect } from 'react';
import { SYRINGE_TYPES } from '../../../types/syringe';
import { InsulinSyringeChart } from './Syringe/InsulinSyringeChart';

interface SyringeEditorProps {
  syringeCapacity?: number;
  syringeUnits?: number;
  onSyringeCapacityChange: (value: number) => void;
  onSyringeUnitsChange: (value: number) => void;
  handleCloseModal: () => void;
}

export function SyringeEditor({
  syringeCapacity = 100,
  syringeUnits = 100,
  onSyringeCapacityChange,
  onSyringeUnitsChange,
  handleCloseModal
}: SyringeEditorProps) {
  // Local state that only propagates on save
  const [localCapacity, setLocalCapacity] = useState(syringeCapacity);
  const [localUnits, setLocalUnits] = useState(syringeUnits);


  const handleSyringeTypeChange = (capacity: number) => {
    const newCapacity = Number(capacity);
    setLocalCapacity(newCapacity);
    // Clamp units to new capacity
    setLocalUnits((prevUnits) => Math.min(prevUnits, newCapacity));
  };
  
  useEffect(() => {
    // Ensure units stay clamped when syringeCapacity changes externally
    setLocalCapacity(syringeCapacity);
    setLocalUnits((prevUnits) => Math.min(syringeUnits, syringeCapacity));
  }, [syringeCapacity, syringeUnits]);
  
  const handleSave = () => {
    // Final clamping before saving
    onSyringeCapacityChange(localCapacity);
    onSyringeUnitsChange(Math.min(localUnits, localCapacity));
    handleCloseModal();
  };
  
  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Syringe Type
        </label>
        <select
          value={localCapacity}
          onChange={(e) => handleSyringeTypeChange(Number(e.target.value))}
          className="w-full p-2 border rounded-lg"
        >
          {SYRINGE_TYPES.map((type) => (
            <option key={type.name} value={type.units}>
              {type.name}
            </option>
          ))}
        </select>
        <div className="mt-4">
        {localCapacity === 30 && (
          <img
            src="/images/u-30-insulin-syringe.png"
            alt="30 Units Syringe"
            className="w-full rounded-lg"
          />
        )}
        {localCapacity === 50 && (
          <img
            src="/images/u-50-insulin-syringe.png"
            alt="50 Units Syringe"
            className="w-full rounded-lg"
          />
        )}
        {localCapacity === 100 && (
          <img
            src="/images/u-100-insulin-syringe.png"
            alt="100 Units Syringe"
            className="w-full rounded-lg"
          />
        )}
        {/* {![30, 50, 100].includes(localCapacity) && (
          <div className="mt-4">
            <label
              htmlFor="custom-units"
              className="block text-sm font-medium text-gray-700 mb-2"
            >
              Enter Custom Units
            </label>
            <input
              id="custom-units"
              type="number"
              value={localUnits}
              onChange={(e) => onSyringeUnitsChange(Number(e.target.value))}
              className="block w-full p-2.5 text-gray-900 bg-white border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500"
              placeholder="Type units here"
            />
          </div>
        )} */}
      </div>
        <p className="mt-1 text-sm text-gray-500">
          Select the syringe type to update the available units.
        </p>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Select Units to Draw from Syringe
        </label>
        <InsulinSyringeChart
          syringeCapacity={localCapacity}
          syringeUnits={localUnits}
          onUnitSelect={setLocalUnits}
        />
        <p className="mt-1 text-sm text-gray-500">
          Drag or click on the syringe to select the number of units.
        </p>
      </div>

      <button
        onClick={handleSave}
        className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition-colors"
      >
        Save Changes
      </button>
    </div>
  );
}